// extracted by mini-css-extract-plugin
export default {"newBackground2":"SLogoNew_newBackground2__KdX+x","newBackground":"SLogoNew_newBackground__A+2gA","g-1":"SLogoNew_g-1__KjGwS","gradientMove":"SLogoNew_gradientMove__G860k"};